import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-recipient",
  "use": "add-recipient-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"add-recipient\"><path d=\"M11 17.75c3.731 0 6.75-3.02 6.75-6.75 0-3.731-3.02-6.75-6.75-6.75A6.746 6.746 0 004.25 11c0 3.731 3.02 6.75 6.75 6.75zM3 11c0-4.422 3.579-8 8-8 4.422 0 8 3.579 8 8 0 4.422-3.579 8-8 8-4.422 0-8-3.579-8-8zm8.65-.6h3.2a.65.65 0 110 1.3h-3.2v3.15a.65.65 0 11-1.3 0V11.7h-3.2a.65.65 0 110-1.3h3.2V7.15a.65.65 0 111.3 0v3.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol